"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Artboard-32"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Artboard-32-2",
  "data-name": "Artboard-32"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M11.84 9.71H28v1.3H11.84zM11.84 13.98H28v1.3H11.84zM4 18.25h24v1.3H4zM4 22.52h14.01v1.3H4z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M6.44 9.53h1l2.45 5.66H8.71l-.55-1.29H5.75l-.55 1.29H4zm1.29 3.36L7 11l-.78 1.85z"
})));
module.exports = exports.default;